let tableId = 'adminUsersDataTable';
let columns = [
    {data: 'id', name: 'id'},
    {data: 'image', name: 'first_name'},
    {data: 'first_name', name: 'first_name'},
    {data: "last_name", name: "last_name"},
    {data: 'email', name: 'email'},
    {data: 'phone', name: 'phone'},
    {data: 'actions', name: 'actions'},
];
let columnDefs = [
    {
        targets: 0,
        orderable: false,
        visible: false,
    },
    {
        targets: 1,
        orderable: false,
        searchable: false,
    },

    {
        targets: 2,
        orderable: true
    },
    {
        targets: 3,
        visible: false,
    },
    {
        targets: 4,
        orderable: true
    },
    {
        targets: 5,
        orderable: false
    },
    {
        targets: 6,
        orderable: false,
        searchable: false
    },
];


let table = $('#' + tableId);

if (table.length > 0) {
    let url = table.attr('data-url');
    let tableDatatable = table.DataTable({
        searchDelay: 500,
        order: [[0, 'desc']],
        language: window.datatableLanguage,
        searching: true,
        serverSide: true,
        processing: true,
        responsive: true,
        ajax: url,
        select: {
            style: 'os',
            selector: 'td:first-child',
            className: 'row-selected'
        },
        columns: columns,
        columnDefs: columnDefs
    });
}
